import { render, staticRenderFns } from "./CompletionPercentage.vue?vue&type=template&id=4d23b262&"
import script from "./CompletionPercentage.vue?vue&type=script&lang=js&"
export * from "./CompletionPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports